export default {
  finance: {
    fxSources: {
        "TCMB": "Türkiye Cumhuriyet Merkez Bankası",
        "ECB": "Avrupa Merkez Bankası",
        "FED": "Federal Reserve (H.10)",
        "BOE": "Bank of England",
        "SNB": "İsviçre Ulusal Bankası",
        "BOJ": "Bank of Japan",
        "CBUAE": "BAE Merkez Bankası",
        "NBP": "Narodowy Bank Polski",
        "OANDA": "OANDA",
        "XE": "XE.com",
        "MANUEL": "Manuel kur girişi"
    },
  },
  common: {
    organization: 'Organizasyon', chooseOrganization: 'Organizasyon seçin', newOrganization: 'Yeni organizasyon',
    loading: 'Yükleniyor…', retry: 'Tekrar dene', search: 'Ara', noMatches: 'Eşleşen kayıt yok.', select: 'Seçin',
    save: 'Kaydet', revert: 'Geri al', cancel: 'Vazgeç', create: 'Oluştur ve aç', close: 'Kapat', edit: 'Düzenle',
    pending: 'Kaydediliyor…', saved: 'Değişiklikler kaydedildi.', dirty: 'Kaydedilmemiş değişiklik', noChanges: 'Değişiklik yok.', alreadySaved: 'Zaten kayıtlı hâlindesiniz.',
    reason: 'Gerekçe', confirm: 'Onayla', back: 'Geri', next: 'Devam', none: 'Yok', required: 'Zorunlu alanları kontrol edin.',
    errors: { refresh: 'Bilgiler yenilenemedi. Son doğrulanan bilgiler gösteriliyor; tamamlanan kayıtlar korunuyor.', unauthorized: 'Oturumunuz sona ermiş. Yeniden giriş yapın.', forbidden: 'Bu işlem için erişim yetkiniz yok.', validation: 'İşlem doğrulanamadı. Alanları ve kayıt durumunu kontrol edin.', upstream: 'Servise ulaşılamıyor. Değişiklik kaydedilmedi.', network: 'Bağlantı kurulamadı. Tekrar deneyin.', contract: 'Sunucu yanıtı beklenen biçimde değil. İşlem doğrulanamadı.', notFound: 'Kayıt bulunamadı veya bu kapsamda kullanılamıyor.' },
    discardTitle: 'Kaydedilmemiş değişikliklerden vazgeçilsin mi?', discardBody: 'Bu ekrandaki taslak değişiklikler kaybolur. Kaydedilmiş bilgiler korunur.', discard: 'Değişikliklerden vazgeç',
  },
  companies: {
    "selectedRoot": "Seçili yapı",
    "chooseRoot": "Yapılandırılacak kök",
    "structureScopeNote": "Yalnız seçili yapı değişir; diğer şirketler korunur.",
    "structurePreserved": "Mevcut şirketleriniz korunur. Seçili şirket yeni holdingin altında aynı kayıt olarak devam eder.",
    "structureDowngrade": "Mevcut holding tek şirkete dönüştürülemez.",
    "structureConflict": "Yapı başka bir işlemle değişti. Güncel bilgileri yükleyip yeniden inceleyin.",
    "structureRefresh": "Güncel yapıyı yükle",
    "structureReadback": "Değişiklik kaydedildi. Güncel liste yüklenemedi; işlemi tekrarlamadan yeniden yükleyin.",
    "independentCompany": "Bağımsız şirket",
    "parentContext": "Üst holding",
    "structureEmpty": "İlk yapıyı oluşturun",
    "structureConfirmed": "Seçili yapı korunur.",
    "structureSelectRequired": "Devam etmek için yapılandırılacak kökü seçin.",
    "monogramFallback": "simge yoksa kullanılır",
    "moneyStorage": "Saklama",
    "decimalStorage": "Decimal128 · {scale} ondalık (defter dövizi)",
    "roundingAwayFromZero": "Yarım değerler sıfırdan uzağa · satır bazında",
    "ledgerRule": "Defter kuralı",
    "debitCreditExclusive": "Borç veya alacak — satırda yalnız bir taraf",
    "groupCurrency": "Raporlama para birimi",
    "groupCurrencyLocked": "Grup Görünümü bu dövizde raporlanır. Mevcut para birimi kilitlidir.",
    "policyReadonly": "Bu kurallar Console’dan değiştirilemez.",
    "policyFixed": "Kod sabiti",
    "invoiceSettings": "App › Fatura › Ayarlar",
    "invoiceSettingsNote": "Fatura numaralandırması ve vade, şirket defterinin yanında yaşar:",
    "moneyScale": "Fonksiyonel ölçek",
    "postedRecords": "Kesilmiş kayıtlar",
    "immutableRecords": "Değiştirilemez",
    "assetHints": {
      "logoLight": "Baskı · PDF · e-posta — koyu renkli logo",
      "logoDark": "App koyu tema · koyu sunum — açık renkli logo",
      "iconLight": "Çip · favicon · rapor mührü (açık)",
      "iconDark": "Çip · favicon (koyu tema)"
    },
    "brandChipNote": "Simge yüklüyse çipte monogram yerine simge görünür — tema hangi setse o kullanılır.",
    "brandPaperNote": "— basılı rapor / PDF; kâğıt her temada açıktır, açık zemin setini kullanır",
    "chooseAsset": "Sürükle / tıkla",
    "statusAndOrder": "Durum ve sıralama",
    "fixedAuthority": "ülke için tek kayıt makamı",
    "companyShort": "Şirket",
    "recordActions": "Şirket işlemleri",
    "auditSlice": "— yalnız bu şirketin kayıtları",
    "auditTitle": "Denetim izi",
    "holdingContext": "Holding düğümü — bağlı şirketler Grup Görünümünde birlikte izlenir",
    "parentNode": "Üst düğüm", "rootNode": "kök düğüm",
    "parentStructureNote": "yapı Yapılandır sihirbazından değişir",
    "allAudit": "Tüm organizasyon izi",
    "addressFields": {
      "countrySearch": "Ülke ara",
      "line2Placeholder": "Kat, daire, bina",
      "line1": "Adres satırı 1",
      "line2": "Adres satırı 2",
      "optional": "— opsiyonel",
      "line1TRPlaceholder": "Mahalle, cadde, numara",
      "line1Placeholder": "Sokak ve numara",
      "line2Unavailable": "İkinci adres satırı henüz kaydedilemiyor.",
      "provinceTR": "İl",
      "districtTR": "İlçe",
      "cityDE": "Şehir (Ort)",
      "city": "Şehir",
      "state": "Bölge / Eyalet",
      "provinceNL": "Provincie",
      "cityEE": "Şehir (Linn)",
      "countyEE": "Maakond",
      "districtCY": "Kaza (District)",
      "cityUS": "Şehir (City)",
      "stateUS": "Eyalet (State)",
      "zip": "ZIP",
      "cityGB": "Şehir (Post town)",
      "postcode": "Postcode",
      "plz": "PLZ",
      "postalCode": "Posta kodu",
      "prefectureJP": "Prefektörlük",
      "cityJP": "Şehir (市区町村)",
      "postalJP": "郵便番号",
      "emirateAE": "Emirlik",
      "areaHK": "Alan (Area)",
      "districtHK": "Bölge (District)",
      "mapTitle": "Adres haritası",
      "mapUnavailable": "Bu alan için harita merkezi bulunmuyor.",
      "approximation": "Pin seçilen il/ilçe merkezini gösterir — parsel doğrulaması geokodlama entegrasyonuyla gelir.",
      "schemaNote": "Alanlar {country} şemasına göre; idari birimler kanonik listeden seçilir.",
      "noPostcode": "{country} adres şeması: posta kodu kullanılmaz."
    },
    "brandIdentity": "Uygulama kimliği",
    "brandAssetsNote": "— dosyalar yalnız buradan yüklenir; aşağıdaki önizlemeler bu setten canlı beslenir",
    "lightChip": "Çip önizlemesi — açık tema",
    "darkChip": "Çip önizlemesi — koyu tema",
    "customHex": "özel hex",
    "brandDocument": "Belge önizlemesi",
    "brandDocumentNote": "Örnek belge — gerçek bir fatura değildir.",
    "legalIdentity": "Yasal kimlik",
    "physicalBranches": "Şubeler · fiziksel yerleşimler",
    "branchNote": "Fiziksel lokasyonlar. Departman ve ekipler organizasyon şemasında tanımlanır.",
    "addBranch": "Şube ekle",
    "structureChoice": "Yapı tipi",
    "structureDetails": "Holding bilgileri",
    "structureSummary": "Özet",
    "holdingChoice": "Holding + bağlı şirketler",
    "singleChoice": "Tek şirket",
    "holdingExplanation": "Birden fazla şirketi bir holding altında yönetin.",
    "singleExplanation": "Bağımsız şirket yapısıyla devam edin.",
    "structureUnavailable": "Yapı dönüşümü şu anda kullanılamıyor. Mevcut şirketleriniz korunur.",
    "moveExisting": "Mevcut şirketin üst düğümünü değiştir",
    "holdingName": "Holding adı",
    "holdingLegalName": "Holding yasal unvanı",
    "structureWarning": "Şirket kayıtları, bağlı birimler ve mali veriler korunarak yeni yapı uygulanır.",
    "legalSchemaNote": "— {country} yasal şeması · merkez adresinin ülkesinden türetilir",
    "legalCountries": { "TR": "Türkiye", "NL": "Hollanda", "EE": "Estonya", "CY": "Kıbrıs", "DE": "Almanya", "US": "ABD", "GB": "Birleşik Krallık" },
    "taxPolicy": "Yuvarlama",
    "noBranches": "Şube tanımlı değil — merkez adresi Genel sekmesinden gelir.",
    ratePrecision: 'Ondalık ayırıcı olarak nokta kullanın. En fazla 28 ondalık basamak desteklenir; değer yuvarlanmadan kaydedilir.',
    closed: 'Kapalı',
    "team": "Takım",
    "manager": "Yönetici",
    "headcount": "Çalışan",
    headcountCount: '{count} Çalışan | {count} Çalışan',
    headcountUnknown: '— Çalışan',
    "sortOrder": "Sıralama",
    "branchAddress": "Şube adresi",
    "phone": "Telefon",
    "email": "E-posta",
    "clearAddress": "Adresi temizle",
    "inheritCurrency": "Şirketten devral ({currency})",
    "makeHeadquarters": "Merkez yap",
    "removeHeadquarters": "Merkez şube işaretini kaldır",
    "headquartersTitle": "Merkez şube tercihi değişsin mi?",
    "setHeadquartersBody": "Bu şube merkez olarak atanır. Mevcut merkez şubenin işareti kaldırılır. Geçmiş kayıtlar korunur.",
    "unsetHeadquartersBody": "Bu şubenin merkez işareti kaldırılır. Başka bir şube otomatik merkez yapılmaz.",
    "archiveUnitName": "Onaylamak için birim adını yazın",
    imageSelected: 'Görsel seçili', noFileSelected: 'Dosya seçilmedi',
    legalLabels: {
      "TR_taxId": "Vergi kimlik no (VKN)",
      "TR_taxOffice": "Vergi dairesi",
      "TR_registrationAuthority": "Ticaret sicil müdürlüğü",
      "TR_registrationNumber": "Ticaret sicil no",
      "TR_nationalRegistryNumber": "MERSİS no",
      "TR_registeredEmail": "KEP adresi (e-tebligat)",
      "DE_taxId": "USt-IdNr.",
      "DE_secondaryTaxId": "Steuernummer",
      "DE_registrationAuthority": "Registergericht (Amtsgericht)",
      "DE_registrationNumber": "Handelsregister-Nr. (HRA/HRB)",
      "DE_registeredEmail": "Resmi e-posta",
      "FR_taxId": "N° TVA intracommunautaire",
      "FR_registrationNumber": "SIREN",
      "FR_secondaryTaxId": "SIRET (merkez)",
      "FR_registrationAuthority": "Greffe (RCS)",
      "FR_registeredEmail": "Resmi e-posta",
      "IT_taxId": "Partita IVA",
      "IT_secondaryTaxId": "Codice Fiscale",
      "IT_registrationAuthority": "CCIAA",
      "IT_registrationNumber": "REA no",
      "IT_registeredEmail": "PEC (sertifikalı e-posta)",
      "GB_registrationNumber": "Company number",
      "GB_taxId": "VAT number",
      "GB_secondaryTaxId": "UTR (Corporation Tax)",
      "US_taxId": "EIN",
      "US_registrationAuthority": "Kuruluş eyaleti",
      "US_registrationNumber": "State file number",
      "NL_registrationNumber": "KVK-nummer",
      "NL_taxId": "BTW-nummer (VAT)",
      "NL_secondaryTaxId": "RSIN",
      "EE_registrationNumber": "Registrikood",
      "EE_taxId": "KMKR (VAT)",
      "CY_registrationNumber": "Şirket no (HE)",
      "CY_taxId": "TIC / VAT",
      "JP_taxId": "Hōjin bangō (法人番号)",
      "JP_secondaryTaxId": "Tekikaku no (適格請求書 T+13)",
      "AE_registrationNumber": "Trade License No",
      "AE_registrationAuthority": "Lisans makamı",
      "AE_taxId": "TRN (VAT)",
      "other_taxId": "Vergi / VAT kimlik",
      "other_registrationNumber": "Ticaret sicil / kayıt no",
      "other_registrationAuthority": "Kayıt makamı",
      "other_registeredEmail": "Resmi e-posta"
},
    "newPeriod": "Yeni mali dönem",
    "noPeriods": "Henüz mali dönem açılmadı.",
    "periodOpen": "Açık",
    "periodClosed": "Kapalı",
    "periodStart": "Başlangıç tarihi",
    "periodEnd": "Bitiş tarihi",
    "closePeriodTitle": "Bu mali dönem kapatılsın mı?",
    "closePeriodBody": "Bu döneme yeni kayıt atılamaz. Bu ekrandan yeniden açılmaz. Kapatma nedenini yazın.",
    "addRate": "Tarihli kur ekle",
    "noRates": "Kayıtlı tarihsel kur yok.",
    "sourceCurrency": "Kaynak para birimi",
    "targetCurrency": "Hedef defter dövizi",
    "rateDate": "Kur tarihi",
    "rateValue": "Kur (1 kaynak para biriminin hedef değeri)",
    "rateImmutable": "Aynı döviz çifti ve tarihteki kurun üzerine yazılamaz. Geçmiş belgelerin kuru korunur.",
    "fxDateNote": "Çevrimler belgenin işlem tarihindeki kurla yapılır. Kaynak değişikliği yeni belgeleri etkiler.",
    "providerUnavailable": "Kaynak seçimi kaydedilir. Bu sağlayıcıdan otomatik kur alımı henüz kullanılamıyor.",
    "manualProviderDescription": "İşlem tarihi için saklanan manuel kurlar.",
    "recordedRateSource": "Kayıtlı kur kaynağı: {source}",
    "manualRateNote": "Manuel kur belirli bir tarih için kaydedilir. Eksik kur sıfır sayılmaz.",
    "saveSourceFirst": "Kur eklemeden önce ayarları kaydedin veya geri alın.",
    "taxPercent": "Varsayılan vergi (%)",
    "taxNote": "Varsayılanı kaldırmak için boş bırakın. 0 değeri açıkça sıfır vergi oranı anlamına gelir.",
    "usTaxNote": "ABD satış vergisi yerel kurallara bağlıdır; burada şirket genelinde varsayılan belirlenmez.",
    "scopeSameCurrency": "Dahil — aynı para birimi",
    "scopeRateAvailable": "Dahil — tarihli kur var",
    "scopeMissingRate": "Hariç — tarihli kur yok",
    "moneyPolicy": "Tutarlar {scale} ondalık basamakla, yarım değerler sıfırdan uzağa yuvarlanarak işlenir. Kesinleşmiş tutarlar değiştirilemez.",
    title: 'Şirketler', subtitle: 'Şirket yapısı, kurumsal bilgiler ve çalışma birimleri', structure: 'Holding yapısı', configure: 'Yapılandır', newCompany: 'Yeni şirket',
    firstTitle: 'İlk organizasyonunuzu oluşturun', firstBody: 'Şirketleri ve birimleri yönetmeye başlamak için bir organizasyon oluşturun.', chooseBody: 'Şirketleri görmek için organizasyon kapsamını seçin.',
    empty: 'Bu organizasyonda henüz şirket yok.', selectCompany: 'Şirket seçin', missingCompany: 'Seçilen şirket bu organizasyonda bulunamadı.',
    treeNote: 'Bu ağaç App’teki şirket seçicisini besler — monogram ve renk oradaki çipte görünür.', treeNoteSingle: 'Tek şirketli kurulum — App’te seçici görünmez. İkinci şirket eklendiğinde yapı holdinge dönüşür.', general: 'Genel', legal: 'Yasal', brand: 'Marka', fiscal: 'Mali', units: 'Birimler', audit: 'Denetim',
    name: 'Görünen ad', legalName: 'Yasal unvan', country: 'Ülke', currency: 'Defter para birimi', parent: 'Üst şirket', root: 'Bağımsız şirket',
    active: 'Aktif', inactive: 'Pasif', companyCount: 'Şirket', subsidiaryCount: 'Bağlı şirket', status: 'Durum', createdAt: 'Oluşturulma',
    companyNamePlaceholder: 'Nova Medya A.Ş.',
    companyLegalPlaceholder: 'Nova Medya Anonim Şirketi',
    departmentNamePlaceholder: 'Yazılım',
    teamNamePlaceholder: 'Platform',
    createStatus: 'Kayıt aktif olarak oluşturulur.',
    createDetails: 'Vergi kimliği, adres ve marka alanlarını kayıt açıldıktan sonra şirketin detay ekranından tamamlayabilirsiniz.',
    groupLabel: 'GRUP',
    unitSummary: '{count} birim · — kişi',
    focusSummary: '{code} · {manager} · — kişi (alt ağaç)',
    holdingSummary: '{count} şirket · {people} · {currency}',
    holdingUnits: '{currency} · {count} birim',
    holdingPeople: '{count} kişi',
    holdingNoEmployees: 'kadro yok',
    holdingRead: {
      loading: 'Holding özeti yükleniyor…',
      unavailable: 'Çalışan sayıları şu anda alınamıyor; birim sayıları güncel.',
      forbidden: 'Holding özetini görüntüleme yetkiniz yok.',
      notFound: 'Holding kapsamı artık mevcut değil. Şirket listesini yenileyin.',
      stale: 'Holding yapısı değişti. Şirket listesini yenileyin.',
      error: 'Holding özeti şu anda alınamıyor.',
    },
    holdingEmpty: 'Bağlı şirket yok.',
    unitNoMatches: 'Eşleşen birim yok.', unitChildrenCount: '{count} alt', unitListTeam: 'takım',
    unitSearch: 'Birim, kod veya yönetici ara',
    addDepartmentTeam: 'Departman / Takım',
    unitLegend: 'Düz kenar = departman, kesikli = takım (en alt birim) · yönetici/kadro HR modülünden beslenir',
    holdingChartNote: 'Kutucuğa tıklamak şirkete geçer; yapı Yapılandır sihirbazından değişir.',
    addCompany: 'Şirket ekle',
    focusUnit: 'Bu birime odaklan',
    addUnit: 'Birim ekle',
    editUnit: 'Birimi düzenle',
    departmentName: 'Departman adı',
    teamName: 'Takım adı',
    optionalCode: '— isteğe bağlı',
    rootDepartment: '— kök (şirkete bağlı)',
    unitParentSearch: 'Birim veya kod ara', selectDepartment: 'Departman seçin…',
    parentDepartmentHint: '— boş = kök departman',
    teamParentHint: '— zorunlu; takım altına takım açılamaz',
    departmentNote: 'Departmanlar alt departman ve takımlar içerebilir. Kod, gider ve raporlarda birimi tanımlar.',
    teamNote: 'Takım tek bir departmana bağlıdır. Kod, HR ve raporlarda birimin kısa kimliğidir.',
    departmentDescription: 'Hiyerarşik — alt departman ve takım alır',
    teamDescription: 'En alt birim — bir departmana bağlı, altı yok',
    hrPanelTitle: 'Yönetici ve kadro',
    hrPanelSource: 'HR modülünden',
    unitHrNote: 'Console yalnız hiyerarşiyi tanımlar. Yönetici ataması ve çalışan-birim eşleşmesi HR modülünde yönetilir.',
    unitHrNewNote: 'Yeni birim için henüz atama bilgisi yok.',
    headcountDescription: {
      known: 'Yalnız bu departmana doğrudan bağlı, aktif çalışanlar sayılır; alt departmanlar dahil değildir.',
      unknown: 'Çalışan sayısı henüz doğrulanmadı.',
      unavailable: 'Çalışan sayısı şu anda alınamıyor.',
      unsupported: 'Takım bazında çalışan sayımı henüz desteklenmiyor.',
    },
    headcountRefreshing: 'Çalışan sayısı yenileniyor.',
    createNote: 'Kayıt aktif olarak oluşturulur. Yasal bilgiler ve marka alanlarını detaydan tamamlayabilirsiniz.',
    address: 'Merkez adresi', street: 'Adres satırı', city: 'Şehir / İlçe', state: 'İl / Bölge', postalCode: 'Posta kodu', addressNote: 'Merkez adresinin ülkesi yasal şemayı belirler.',
    taxId: 'Vergi kimlik numarası', vatNumber: 'KDV / VAT numarası', taxOffice: 'Vergi dairesi', registrationAuthority: 'Kayıt makamı', registrationNumber: 'Ticaret sicil numarası', secondaryTaxId: 'İkincil vergi kimliği', registeredEmail: 'Resmi / KEP e-posta adresi',
    legalNote: "Yasal unvan ve vergi numarası App'te de bulunur; bu sekmedeki diğer alanlar yalnız Console'da görünür.", removeAsset: 'Görseli kaldır', removeAssetTitle: 'Marka görseli kaldırılsın mı?', removeAssetBody: 'Bu görsel marka setinden kaldırılır. Değişiklik Kaydet ile uygulanır; önceden düzenlenmiş belgeler korunur.', brandAssets: "Marka varlıklarını yükleyin", logoLight: 'Logo — açık zemin', logoDark: 'Logo — koyu zemin', iconLight: 'Simge — açık zemin', iconDark: 'Simge — koyu zemin', chooseFile: 'Görsel seç', monogram: 'Monogram', accentColor: "Aksan rengi", documentFooter: 'Belge altbilgisi', brandPreview: 'Belge ve uygulama önizlemesi', logoUrl: 'Mevcut logo adresi', noLogo: 'Görsel yok', previewOnly: 'Kaydedilmemiş önizleme', invalidImage: 'PNG, JPEG veya WebP görsel seçin (en fazla 5 MB ve 4096 × 4096 piksel).',
    currencyLocked: 'İlk belge bu defterde kesildiği için kilitli. Döviz değişikliği yeni şirket kaydı gerektirir.', currencyEditable: 'İlk belge kesildiği anda para birimi kilitlenir.', periods: 'Mali dönemler', periodNote: 'Kapalı döneme kayıt atılamaz. Düzeltme açık dönemde ters kayıtla yapılır.', closePeriod: 'Dönemi kapat', groupScope: 'Grup görünümü kapsamı', groupNote: 'Kur bilgisi olmayan şirketler konsolidasyona dahil edilemez.', fxSource: 'Kur kaynağı', manual: 'Manuel', fxHistory: 'Geçmiş kurlar', taxes: 'KDV / VAT varsayılanı', monetaryPolicy: 'Para politikası', monetaryNote: 'Defter hareketlerinin para birimi ve kesinleşmiş tutarları sonradan değiştirilmez.', archive: 'Şirketi arşivle', archiveTitle: 'Şirket arşivlensin mi?', archiveBody: 'Şirket aktif listeden kaldırılır. Geçmiş kayıtlar ve denetim izi korunur.', archiveName: 'Onaylamak için şirket adını yazın', deactivateTitle: 'Şirket pasif yapılsın mı?', deactivateBody: 'Şirket yeni işlemler için pasif duruma geçer. Mevcut kayıtları korunur.', deactivate: 'Pasif yap', activate: 'Aktif yap',
    unitChartEmpty: 'Bu şirkette tanımlı birim yok — kurulum sürüyor.',
    archiveUnitChildren: 'Önce alt departman ve takımları taşıyın veya silin.',
    archiveUnitReadRequired: 'Arşivlemeden önce güncel birim yapısını yükleyin.',
    archiveConflictTitle: 'Yapı değişti', archiveConflictBody: 'Yapı bu sırada başka bir işlemle değişti. Listeyi yenileyip yeniden deneyin.', archiveConflictAction: 'Yenile', archiveRefreshed: 'Liste yenilendi — girdiğiniz neden korunuyor.',
    unitListMore: 'İlk 80 satır gösteriliyor — aramayla daraltın ({count} eşleşme).',
    unitOverflowTop: '+{count} birim daha',
    unitOverflowTopHint: 'eşik aşıldı — şema özetler',
    unitOverflowNested: '+{count} birim',
    unitOverflowNestedHint: 'tümü listede',
    configureTitle: 'Şirket yapısını yapılandır', configureBody: "Mevcut bir şirketi başka bir şirketin altına taşıyın. Taşınacak şirketi ve üst düğümü inceleyerek onaylayın.", moveCompany: 'Taşınacak şirket', reviewStructure: 'Yapı değişikliğini inceleyin', applyStructure: 'Yapıyı uygula', unitList: 'Liste', unitChart: 'Şema', newUnit: 'Yeni birim', unitName: 'Birim adı', unitCode: 'Kod', unitType: 'Birim türü', department: 'Departman', branch: 'Şube', parentUnit: 'Üst departman', headquarters: 'Merkez', hrNote: 'Console hiyerarşiyi tanımlar. Yönetici ve çalışan atamaları HR modülünde yönetilir.', noUnits: 'Henüz birim kaydı yok.', focus: 'Odakla', allUnits: 'Tüm birimler', archiveUnit: 'Birimi arşivle', archiveUnitTitle: 'Birim arşivlensin mi?', archiveUnitBody: 'Birim aktif yapıdan kaldırılır. Geçmiş ilişkiler korunur.',
    documentFooterEmpty: 'Belge altbilgisi henüz girilmedi — bu satır faturaların altında görünecek',
    auditOpen: 'Organizasyon denetimine git',
  },
}
